<template>
  <div class="select-method">
    <MethodModal
      v-if="configuration && isShowMethodModal"
      :isOpen="true"
      :method="methodData"
      :deviceConfiguration="configuration"
      @close="handleModalClosed"
      @create="methodUpdatedInModal"
      @edit="methodUpdatedInModal"
    />

    <SelectMethodAsPreset
      :method="method"
      :configuration="configuration"
      class="select-method__select"
      :class="{
        'select-method__select--can-edit': method != null,
        'select-method__select--no-permissions': !hasPermissionToEdit,
      }"
      @change="onMethodChange"
    />

    <template v-if="hasPermissionToEdit">
      <template v-if="method">
        <Btn v-if="isMethodCompatible" class="select-method__btn" @click="editMethod">Edit</Btn>
        <template v-else>
          <PopupHelper
            text="Device configuration has changed. You can't use this method. Please select another one from the list or create a new one to continue"
          >
            <div class="select-method__warning">
              <IconMaterial title="error" size="18" />
              Not compatible
            </div>
          </PopupHelper>
          <FixMethodButton
            v-if="deviceId && configuration"
            :method="method"
            :configuration="configuration"
            :deviceId="deviceId"
            class="select-method__btn"
            @fix="onMethodChange"
          />
        </template>
        <div></div>
      </template>
      <Btn class="select-method__btn" @click="addMethod">Add</Btn>
    </template>
  </div>
</template>

<script>
  import _ from 'lodash';
  import MethodModal from 'components/blocks/reactComponents/MethodModal';
  import SelectMethodAsPreset from '@/components/element/SelectMethodAsPreset.vue';
  import Btn from '@/uikitBase/btns/Btn.vue';
  import { AuthService } from '@/services/auth.service';
  import IconMaterial from '@/uikitBase/icons/IconMaterial.vue';
  import PopupHelper from '@/uikitProject/popups/info/PopupHelper.vue';
  import FixMethodButton from 'components/element/FixMethodButton.vue';

  const EVENT_UPDATE_METHOD = 'update:method';

  export default {
    name: 'SelectMethodComponent',

    components: {
      PopupHelper,
      IconMaterial,
      Btn,
      SelectMethodAsPreset,
      MethodModal,
      FixMethodButton,
    },

    model: {
      prop: 'method',
      event: EVENT_UPDATE_METHOD,
    },

    props: {
      method: Object,
      configuration: { type: Object, default: undefined },
      deviceId: {
        type: String,
      },
      isMethodCompatible: {
        type: Boolean,
      },
    },

    data() {
      return {
        methodData: this.method,
        hasPermissionToEdit: AuthService.userData().role === 'admin',
        isShowMethodModal: false,
      };
    },
    watch: {
      method(newMethod) {
        this.methodData = newMethod;
      },
    },
    methods: {
      onMethodChange(methodData) {
        this.$emit(EVENT_UPDATE_METHOD, _.clone(methodData));
      },

      methodUpdatedInModal(methodData) {
        this.$store.commit('resetMethods');
        this.methodData = methodData;
        this.onMethodChange(methodData);
      },

      handleModalClosed() {
        this.isShowMethodModal = false;
      },

      showMethodModal() {
        if (!this.configuration) {
          this.notifyError('Unable to open method editor: device configuration is unavailable.');
          return;
        }
        this.isShowMethodModal = true;
      },

      editMethod() {
        this.methodData = this.method;
        this.showMethodModal();
      },
      addMethod() {
        this.methodData = undefined;
        this.showMethodModal();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .select-method {
    display: flex;
    align-items: center;

    &__select {
      width: calc(100% - 70px);

      &--can-edit {
        width: calc(100% - 140px);
      }

      &--no-permissions {
        width: 100%;
      }
    }

    &__btn {
      margin-left: 10px;
      width: 60px;
      flex: none;
    }

    &__warning {
      display: flex;
      align-items: center;
      margin-top: 7px;
      margin-bottom: 4px;
      margin-left: 10px;
      white-space: nowrap;
      flex: 0 0;
      gap: 5px;
      font-weight: $weight-bold;
      color: $color-text-danger;
    }
  }
</style>
